import { render, staticRenderFns } from "./oldmanAdd.vue?vue&type=template&id=0158bbd9&scoped=true&"
import script from "./oldmanAdd.vue?vue&type=script&lang=js&"
export * from "./oldmanAdd.vue?vue&type=script&lang=js&"
import style0 from "./oldmanAdd.vue?vue&type=style&index=0&id=0158bbd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0158bbd9",
  null
  
)

export default component.exports